import { render, staticRenderFns } from "./PassageChoiseQuestionDrill.vue?vue&type=template&id=45e47961&scoped=true"
import script from "./PassageChoiseQuestionDrill.vue?vue&type=script&lang=js"
export * from "./PassageChoiseQuestionDrill.vue?vue&type=script&lang=js"
import style0 from "./PassageChoiseQuestionDrill.vue?vue&type=style&index=0&id=45e47961&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e47961",
  null
  
)

export default component.exports